import React from "react";
import { createRoot } from "react-dom/client";

import SearchBoxWide from "./searchbox/searchbox-wide";
import SearchBoxIcon from "./searchbox-icon/searchbox-icon";
import SearchBoxFlyout from "./searchbox-flyout/searchbox-flyout";
import SearchBoxGrid from "./searchbox-grid/searchbox-grid";
import SearchBoxMegaMenu from "./searchbox-megamenu/searchbox-megamenu";

import { detectContext } from "../util/contextDetection";

const detectedContext = detectContext();

if (typeof window.__PRELOADED_SEARCHBOX_WIDE_STATE__ !== "undefined") {
    const propsSearchBoxWide = JSON.parse(
        JSON.stringify(window.__PRELOADED_SEARCHBOX_WIDE_STATE__)
    );
    const rootSearchBoxWide = createRoot(document.getElementById("search-box-wide-container")!);
    rootSearchBoxWide.render(
        <SearchBoxWide {...propsSearchBoxWide} detectedContext={detectedContext} />
    );
}

if (typeof window.__PRELOADED_SEARCHBOX_ICON_STATE__ !== "undefined") {
    const propsSearchBoxIcon = JSON.parse(
        JSON.stringify(window.__PRELOADED_SEARCHBOX_ICON_STATE__)
    );
    const rootSearchBoxIcon = createRoot(document.getElementById("search-box-icon-container")!);
    rootSearchBoxIcon.render(<SearchBoxIcon {...propsSearchBoxIcon} />);
}

if (typeof window.__PRELOADED_SEARCHBOX_FLYOUT_STATE__ !== "undefined") {
    const propsSearchBoxFlyout = JSON.parse(
        JSON.stringify(window.__PRELOADED_SEARCHBOX_FLYOUT_STATE__)
    );
    const rootSearchBoxFlyout = createRoot(document.getElementById("search-box-flyout-container")!);
    rootSearchBoxFlyout.render(
        <SearchBoxFlyout {...propsSearchBoxFlyout} detectedContext={detectedContext} />
    );
}

if (typeof window.__PRELOADED_SEARCHBOX_GRID_STATE__ !== "undefined") {
    const propsSearchBoxGrid = JSON.parse(
        JSON.stringify(window.__PRELOADED_SEARCHBOX_GRID_STATE__)
    );
    const rootSearchBoxGrid = createRoot(document.getElementById("search-box-grid-container")!);
    rootSearchBoxGrid.render(
        <SearchBoxGrid {...propsSearchBoxGrid} detectedContext={detectedContext} />
    );
}

if (typeof window.__PRELOADED_SEARCHBOX_MEGAMENU_STATE__ !== "undefined") {
    const propsSearchBoxMegaMenu = JSON.parse(
        JSON.stringify(window.__PRELOADED_SEARCHBOX_MEGAMENU_STATE__)
    );
    const rootSearchBoxMegaMenu = createRoot(
        document.getElementById("search-box-megamenu-container")!
    );
    rootSearchBoxMegaMenu.render(
        <SearchBoxMegaMenu {...propsSearchBoxMegaMenu} detectedContext={detectedContext} />
    );
}
